import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import usePaginationParams from '@hooks/usePaginationParams';

import type { CampaignExecutionType } from './types';

const useGetList = () => {
  const [loading, setLoading] = useState(true);
  const [campaignExecutionList, setCampaignExecutionList] = useState<CampaignExecutionType[]>([]);
  const [totalPages, setTotalPages] = useState(0);

  const getCampaignExecutionList = useCallback(async ({ page = 1, limit = 10 }) => {
    setLoading(true);
    try {
      const response = await api.get('/campaign_execution', {
        params: {
          pageIndex: page,
          pageLimit: limit,
        },
      });
      setCampaignExecutionList(response.data.data);
      setTotalPages(response.data.total);
    } catch (error) {
      toast.error('Erro ao carregar os atendimentos. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to get campaign execution list'), {
        error,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  usePaginationParams({ onParamsChange: getCampaignExecutionList });

  return {
    getCampaignExecutionList,
    campaignExecutionList,
    totalPages,
    loading,
  };
};

export default useGetList;
